<div class="locked-prompt-container">
  <div class="lock-message-container">
    <ng-content></ng-content>
  </div>
</div>
